import React from 'react';
import RouterPaths from '../../common/RouterPaths';
import { withAppContext } from '../../contexts/AppContext';
import { useLocation } from 'react-router-dom';
import '../../resources/styles/scss/components/common/header.css';
import SearchBar from '../search/SearchBar';
import BrowserHistory from '../utils/BrowserHistory';
import HeaderNav from './HeaderNav';
import HeaderActionMenu from './HeaderActionMenu';
import HeaderToolbarActions from './HeaderToolbarActions';
import { FeatureFlagContext } from '../../contexts/FeatureFlagContext';

import { Box } from '@amzn/awsui-components-core';

const Header = () => {
  const location = useLocation();
  const featureFlagContext = React.useContext(FeatureFlagContext);
  const isUxRedesignEnabled = featureFlagContext?.isFeatureEnabled('UxRedesign') ?? false;

  const navigateHome = () => {
    BrowserHistory.push('/');
  };

  const renderSearchBar = () => {
    if (location.pathname === RouterPaths.HOME_PAGE) {
      return null;
    }
    return <SearchBar />;
  };

  const renderLogo = () => {
    return (
      <div className="header-title-container">
        <Box textAlign="center">
          <div className="header-logo-text" onClick={navigateHome}>
            <Box color="inherit" display="inline" fontWeight="bold">
              AWS
            </Box>{' '}
            Prescriptive Guidance Library
          </div>
        </Box>
        {renderSearchBar()}
      </div>
    );
  };

  return (
    <header id="page-header">
      <div id="page-header-container" className="header-container">
        <div className="header-nav">
          {renderLogo()}
          <HeaderNav />
        </div>
        <div className="action-menu">
          <HeaderActionMenu />
          {isUxRedesignEnabled && <HeaderToolbarActions />}
        </div>
      </div>
    </header>
  );
};

export default withAppContext(Header);
